import { Redirect } from "react-router-dom";

import { WALLET_CARDS_UI_ENABLED } from "../../../Utils/ibProductFeatures";

/** @deprecated Use /cartoes */
export const PersonalCard = () => (
  <Redirect to={WALLET_CARDS_UI_ENABLED ? "/cartoes" : "/"} />
);
